import { THEME, NODE_TYPE_LABELS, formatCurrency } from "../utils/theme";

/**
 * Tooltip — floating tooltip on node hover.
 */
export default function Tooltip({ node, x, y, currencySymbol = "\u00a3" }) {
  if (!node) return null;

  return (
    <div style={{
      position: "fixed", left: x + 16, top: y - 10, zIndex: 100,
      background: THEME.surface, border: `1px solid ${THEME.borderLight}`,
      borderRadius: 8, padding: "10px 14px", maxWidth: 240,
      boxShadow: "0 8px 32px rgba(0,0,0,0.5)", pointerEvents: "none",
      fontFamily: "inherit",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
        <span style={{
          width: 8, height: 8,
          borderRadius: node.type === "contact" ? "50%" : 2,
          background: THEME.nodeColors[node.type].fill,
          display: "inline-block",
        }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: THEME.text }}>{node.label}</span>
      </div>
      <span style={{
        fontSize: 10, color: THEME.textSecondary,
        textTransform: "uppercase", letterSpacing: "0.06em",
      }}>
        {NODE_TYPE_LABELS[node.type]}
      </span>
      {node.role && <div style={{ fontSize: 11.5, color: THEME.textSecondary, marginTop: 4 }}>{node.role}</div>}
      {node.value && (
        <div style={{ fontSize: 11.5, color: THEME.accent, marginTop: 4, fontFamily: "monospace" }}>
          {formatCurrency(node.value, currencySymbol)}
        </div>
      )}
      {node.stage && (
        <div style={{
          marginTop: 4, display: "inline-block",
          padding: "2px 8px", borderRadius: 4,
          fontSize: 10, fontWeight: 500,
          background: (THEME.stageColors[node.stage] || "#666") + "22",
          color: THEME.stageColors[node.stage] || "#aaa",
          textTransform: "capitalize",
        }}>
          {node.stage}
        </div>
      )}
    </div>
  );
}
